export default "__VITE_ASSET__Nt8Nw5D$__"